import React from 'react';
import { useMutation } from '@apollo/client';
import SaveOnboardingSettingsMutation from './SaveOnboardingSettingsMutation';

interface ISaveOnboardingSettingsConnectorApolloProps {
  children: ({
    saveOnboardingSettings,
  }: {
    saveOnboardingSettings: (variables: any) => Promise<any>;
  }) => React.ReactElement;
}

const SaveOnboardingSettingsConnectorApollo: React.FC<
  ISaveOnboardingSettingsConnectorApolloProps
> = ({ children }) => {
  const [save] = useMutation(SaveOnboardingSettingsMutation);

  const saveOnboardingSettings = async (variables: any) => {
    const response = await save({
      variables: { ...variables },
    });

    return response.data.me.saveOnboardingSettings;
  };

  return children({ saveOnboardingSettings });
};

export default SaveOnboardingSettingsConnectorApollo;
